export default __webpack_public_path__ + "static/media/818 1.89b77357.jpg";